import { device } from '@/utils/index'

const content = [
  // 第二章 第二节
  // 节标题
  {
    key: 'section2.2',
    type: "title",
    category: 2, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    shortText: "<span style=\"font-family:'Times New Roman'\">2<\/span>．<span style=\"font-family:'Times New Roman'\">2<\/span>", // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: '文旌数字教材功能介绍', // *必填* 标题文本内容
    textStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 26, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#333', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
    },
  },
  // 正文
  {
    key: 'section2.2.1', // *必填* 唯一标识
    type: 'text', // *必填* 类型：正文
    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
      {
        key: 'section2.2.1.1', // *必填* 唯一标识
        category: 'text', // *必填* 内容类型 text：文本 
        text: '文旌数字教材包括多媒体集成、内容拓展、交互练习、辅助工具四大功能版块，能够实现课堂教学与知识传授的生动性、趣味性，让学生可感可知、入脑入心，从而提升课堂教学效果和学习体验。', // *必填* 文本内容
        textStyle: {
        },
      },
    ],
    textStyle: {
      // fontFamily: 'xxx', // 字体，本地配置的字体
      // fontSize: 20, // 文字大小  默认：20
      // lineHeight: 40, // 行高  默认：36
      textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#333', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
    },
  },
  // 功能弹窗
  {
    key: 'section2.2.2', // *必填* 唯一标识
    type: 'mix-popup', // *必填* 类型：功能弹窗
    templateType: 2, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺
    // title: '思考：什么是数字教材？', // 标题
    // titleStyle: {},
    content: [ // *必填* 所有数据内容
      // 多模块类型
      {
        key: 'section2.2.2.1', // *必填* 唯一标识
        type: 'mix', // *必填* 类型：组合
        title: '多媒体集成', // 标题
        moreTitle: '请选择多媒体类型', // 标题
        info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        content: [
          // 图片集
          {
            key: 'section2.2.2.1.1', // *必填* 唯一标识
            type: 'image', // *必填* 类型：图片
            title: '图片', // 标题
            // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
            // cover: require("@/assets/images/bookContent/single_video.png"),
            content: [ // *必填* 图片列表
              {
                key: 'section2.2.2.1.1.1', // *必填* 唯一标识
                url: require("@/assets/images/books/bookExample/introduction/图1  步辇图.jpg"), // *必填* 图片地址
                title: '图1  步辇图', // 图片标题
                titleStyle: {
        
                }
              },
              {
                key: 'section2.2.2.1.1.2', // *必填* 唯一标识
                url: require("@/assets/images/books/bookExample/introduction/图2  阿尔塔米拉洞穴壁画.jpg"), // *必填* 图片地址
                title: '图2  阿尔塔米拉洞穴壁画', // 图片标题
                titleStyle: {
                  
                }
              },
              {
                key: 'section2.2.2.1.1.3', // *必填* 唯一标识
                url: require("@/assets/images/books/bookExample/introduction/图3  人面鱼纹彩陶盆.jpeg"), // *必填* 图片地址
                title: '图3  人面鱼纹彩陶盆', // 图片标题
                titleStyle: {
                  
                }
              }
            ],
          },
          // 视频
          {
            key: 'section2.2.2.1.2', // *必填* 唯一标识
            type: 'video', // *必填* 类型：视频
            title: '视频', // 标题
            // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
            // cover: require("@/assets/images/bookContent/single_video.png"),
            content: [ // *必填* 视频列表
              {
                key: 'section2.2.2.1.2.1', // *必填* 唯一标识
                url: require("@/assets/video/王小旌卖米的故事.mp4"), // *必填* 视频地址
                cover: require("@/assets/images/books/bookExample/introduction/video-cover-1.png"), // 视频封面
                title: '王小旌卖米的故事', // 视频标题
                titleStyle: {
                  // 根据需要是否加标题样式
                  // fontFamily: 'xxx', // 字体，本地配置的字体
                  // fontSize: 20, // 文字大小  默认：20
                  // lineHeight: 40, // 行高  默认：36
                  // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                  // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                  // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                  // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                  // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                  // color: '#333', // 文本颜色  默认：#00a8ac
                  // backgroundColor: '#FFF', // 背景颜色  默认：无
                }
              },
              {
                key: 'section2.2.2.1.2.2', // *必填* 唯一标识
                url: require("@/assets/video/如何运用渗透定价策略.mp4"), // *必填* 视频地址
                cover: require("@/assets/images/books/bookExample/introduction/video-cover-2.png"), // 视频封面
                title: '如何运用渗透定价策略', // 视频标题
                titleStyle: {
                  
                }
              },
              {
                key: 'section2.2.2.1.2.3', // *必填* 唯一标识
                url: require("@/assets/video/从客户投诉中完善企业服务.mp4"), // *必填* 视频地址
                cover: require("@/assets/images/books/bookExample/introduction/video-cover-3.png"), // 视频封面
                title: '从客户投诉中完善企业服务', // 视频标题
                titleStyle: {
                  
                }
              },
            ],
          },
          // 三维模型
          {
            key: 'section2.2.2.1.3', // *必填* 唯一标识
            type: '3DModel', // *必填* 类型：音频
            title: '三维模型', // 标题
            // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
            // cover: require("@/assets/images/bookContent/single_video.png"),
            content: [ // *必填* 音频列表
              {
                key: 'section2.2.2.1.3.1', // *必填* 唯一标识
                url: 'https://file.bjjqe.net/wk/P02242/wk/0-0-1.htm', // *必填* 地址
                cover: require("@/assets/images/books/bookExample/introduction/threeD-cover-1.png"), // 封面
                title: '单缸活塞式内燃机', // 标题
                titleStyle: {}
              },
              {
                key: 'section2.2.2.1.3.2', // *必填* 唯一标识
                url: 'https://file.bjjqe.net/wk/P02242/wk/0-3-8.htm', // *必填* 地址
                cover: require("@/assets/images/books/bookExample/introduction/threeD-cover-2.png"), // 封面
                title: '槽轮机构的工作原理', // 标题
                titleStyle: {}
              },
              {
                key: 'section2.2.2.1.3.3', // *必填* 唯一标识
                url: 'https://code.bjjqe.net/2/2/15/jxsjjc-zxl/3-2.htm', // *必填* 地址
                cover: require("@/assets/images/books/bookExample/introduction/threeD-cover-3.png"), // 封面
                title: '内燃机配气机构', // 标题
                titleStyle: {}
              }
            ]
          },
          // 可交互动态图像
          {
            key: 'section2.2.2.1.4', // *必填* 唯一标识
            type: 'charts', // *必填* 类型：音频
            title: '可交互\n动态图像', // 标题
            // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
            // cover: require("@/assets/images/bookContent/single_video.png"),
            content: [ // *必填* 音频列表
              // {
              //   key: 'section2.2.2.1.3.1', // *必填* 唯一标识
              //   url: 'https://file.bjjqe.net/wk/P01933/wk/0-1-1.htm', // *必填* 地址
              //   cover: require("@/assets/images/bookContent/single_video_1.png"), // 封面
              //   title: '三维模型标题', // 标题
              //   titleStyle: {}
              // },
              // {
              //   key: 'section2.2.2.1.3.2', // *必填* 唯一标识
              //   url: 'https://file.bjjqe.net/wk/P01933/wk/0-1-2.htm', // *必填* 地址
              //   cover: require("@/assets/images/bookContent/single_video_1.png"), // 封面
              //   title: '三维模型标题2', // 标题
              //   titleStyle: {}
              // }
            ]
          },
        ]
      },
      // 内容拓展
      {
        key: 'section2.2.2.2', // *必填* 唯一标识
        type: 'text', // *必填* 类型：
        title: '内容拓展', // 标题
        info: '气泡、百科一键链接、快速查询，拓展学习更便捷',
        content: [ // *必填* 内容列表
          // 标题
          {
            key: 'section2.2.2.2.1',
            type: "title",
            category: 6, // *必填* 分类 1：章头 2：节头 3：小标题 ...
            // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
            text: '推进教材数字化转型是时代要求和趋势', // *必填* 标题文本内容
            textStyle: {
              // fontFamily: 'Arial', // 字体，本地配置的字体
              // fontSize: 32, // 文字大小  默认：26
              // lineHeight: 40, // 行高  默认：46
              // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
              // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              // color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
              // backgroundImage: require('@/assets/images/books/bookExample/title-center.png')// 背景图片  默认：无
            },
          },
          // 正文
          {
            key: 'section2.2.2.2.2', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section2.2.2.2.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本 
                text: '习近平总书记在谈到', // *必填* 文本内容
                textStyle: {
                },
              },
              {
                key: 'section2.2.2.2.2.2', // *必填* 唯一标识
                category: 'popover', // *必填* 内容类型 text：文本 
                text: '扎实推动教育强国建设', // *必填* 文本内容
                // popTitle: 'xxx', // 气泡的标题 气泡的标题与内容至少需要存在一个
                popText: '这是习近平总书记2023年5月29日在二十届中央政治局第五次集体学习时的讲话。', // 气泡的内容
                textStyle: {
                },
              },
              {
                key: 'section2.2.2.2.2.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本 
                text: '时指出：从教育大国到教育强国是一个系统性跃升和质变，必须以改革创新为动力。加快推进教材', // *必填* 文本内容
                textStyle: {
                },
              },
              {
                key: 'section2.2.2.2.2.4', // *必填* 唯一标识
                category: 'popover', // *必填* 内容类型 text：文本 
                text: '数字化', // *必填* 文本内容
                // popTitle: 'xxx', // 气泡的标题 气泡的标题与内容至少需要存在一个
                popText: '指在某个领域的各个方面或某种产品的各个环节都采用数字信息处理技术，即通过计算机系统把文字、图像等不同形式的信息转换成数字编码进行处理。', // 气泡的内容
                popLink: 'https://hanyu.baidu.com/hanyu-page/term/detail?wd=%E6%95%B0%E5%AD%97%E5%8C%96&device=pc&from=home', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                textStyle: {
                },
              },
              {
                key: 'section2.2.2.2.2.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本 
                text: '转型在各种教育改革创新中具有非常重要的地位。教育强国建设战略需求、信息科学技术的高速发展和应用普及，要求教材必须顺应时代的发展，教材数字化转型是必然的趋势。', // *必填* 文本内容
                textStyle: {
                },
              },
              
            ],
            textStyle: {
              // fontFamily: 'xxx', // 字体，本地配置的字体
              // fontSize: 20, // 文字大小  默认：20
              // lineHeight: 40, // 行高  默认：36
              textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              // color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
          // 正文
          {
            key: 'section2.2.2.2.3', // *必填* 唯一标识
            type: 'text', // *必填* 类型：正文
            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
              {
                key: 'section2.2.2.2.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本 
                text: '（资料来源：教育部http://www.moe.gov.cn/jyb_xwfb/moe_2082/2024/2024_zl04/202403/t20240314_1120287.html）', // *必填* 文本内容
                textStyle: {
                  fontSize: device.isMobile ? 24 :16, // 文字大小  默认：24
                  color: '#666', // 文本颜色
                },
              },
              
            ],
            textStyle: {
              // fontFamily: 'xxx', // 字体，本地配置的字体
              // fontSize: 20, // 文字大小  默认：20
              // lineHeight: 40, // 行高  默认：36
              // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
              // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
              // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
              // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
              // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
              // color: '#333', // 文本颜色  默认：#00a8ac
              // backgroundColor: '#FFF', // 背景颜色  默认：无
            },
          },
        ]
      },
      // 互动答题
      {
        key: 'section2.2.2.3', // *必填* 唯一标识
        type: 'interactionQuestion', // *必填* 类型：
        title: '交互练习', // 标题
        info: '场景互动、趣味答题，学习与实践并重，知识掌握更牢固',
        cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 答题列表
          // 交互 拼图/组装
          {
            "topic_id": 100,
            "id": 100,
            "type_id": 10,
            "typenm": "互动题",
            "shorttag": "",
            "showway": "",
            "topic_score": "8.00",
            "isauto": 0,
            "info": "",
            "km": "",
            "stem_url": "",
            "audiofile": "",
            "audiofile_suffix": "",
            "audiofile_title": "附件下载",
            "is_collect": 0,
            "status": 0,
            "is_play": 0,
            "issign": 0,
            "isok": 0,
            "isdone": 0,
            "getscore": 0,
            "comment": "",
            "ischeck": 0,
            "ps_title": "一、场景题",
            "ps_info": "场景互动题将学习与实践相结合，使知识掌握更牢固。",
            "topic_sub": [
              {
                "shorttag": "",
                "direction": 0,
                "type_id": 10,
                "typenm": "互动题",
                "score": "8.00",
                "topic_id": 57,
                "sub_id": 1,
                "isauto": 0,
                "para44_id": 0,
                "upload_explain": "",
                "options": [],
                "showway": "",
                "subinfo": "",
                "subanalysis": "",
                "sortid": 1,
                "file_name": "",
                "user_answer": [],
                "brief_answer": {},
                "user_status": -1,
                "answer_img": {},
                "topic_answer": [
                  {
                    "topic_id": 57,
                    "sub_id": 1,
                    "sortid": 1,
                    "ask": "",
                    "answer": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">在长期的实践中，广大劳动者逐渐培育形成了“执着专注、精益求精、一丝不苟、追求卓越”的工匠精神。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">执着专注既是一种锲而不舍的工作态度，也是一种埋头苦干的工作习惯。崔兴国从事水电装备制造工作30多年，带领团队持续攻关、突破创新，正是执着专注的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">精益求精即要有一颗进取之心，以高标准要求自己，不断钻研工艺知识、提高技能水平。为了保证水轮机组转轮平稳运行，实现转轮静平衡试验目标，崔兴国采用了精准导向工装和扶正调整技术，使各项参数指标均优于精品标准，正是精益求精的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">一丝不苟即做事认真，不放过任何一个细节。周晶辉面对烦琐的工作，勤勤恳恳，不断试验，成功探索出了可以使焊接时各个零部件受热均匀，减少车体变形情况的焊接工艺，正是一丝不苟的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">追求卓越即不断进取、敢于开拓创新、勇于突破自我。在没有技术参考的情况下，周晶辉用时一个多月，研究出了一套可在半小时内完成精准切割的切割方法，正是追求卓越的体现。<\/span><\/p>",
                    "askend": null,
                    "answer_id": 1,
                    "answer_url": "",
                    "answertitle": null,
                    "score": "8.00",
                    "operation_score": 0
                  }
                ],
                "topic_content": {
                  // 交互 拼图/组装
                  key: 'section2.2.2.3.1', // *必填* 唯一标识
                  type: 'action', // *必填* 类型：交互
                  actionType: 4, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                  title: '请选择正确的主机内部硬件配置名称。', // 标题
                  isExample: 1,
                  titleStyle: {},
                  content: {
                    // 拼图/组装
                    key: 'section2.2.2.3.1.1', // *必填* 唯一标识
                    cover: require("@/assets/images/books/bookExample/jigsaw-back.png"),
                    content: [
                      {
                        top: 63,
                        left: 24,
                        width: 153,
                        height: 82,
                        options: [
                          {
                            value: 'key1',
                            label: '电源'
                          },
                          {
                            value: 'key2',
                            label: '光驱'
                          },
                          {
                            value: 'key3',
                            label: '电源引出线'
                          },
                          {
                            value: 'key4',
                            label: '内存条'
                          },
                          {
                            value: 'key5',
                            label: '硬盘'
                          },
                        ],
                        answerKey: 'key1'
                      },
                      {
                        top: 203,
                        left: 134,
                        width: 87,
                        height: 88,
                        options: [
                          {
                            value: 'key1',
                            label: '光驱'
                          },
                          {
                            value: 'key2',
                            label: 'CPU与散热器'
                          },
                          {
                            value: 'key3',
                            label: '显卡'
                          },
                          {
                            value: 'key4',
                            label: '硬盘'
                          },
                        ],
                        answerKey: 'key2'
                      }
                    ],
                  },
                },
                "video_list": [],
                "isok": 0,
                "isdone": 0,
                "concat_answer": "",
                "user_concat_answer": ""
              }
            ]
          },
          // 交互 排一排
          {
            "topic_id": 100,
            "id": 100,
            "type_id": 10,
            "typenm": "互动题",
            "shorttag": "",
            "showway": "",
            "topic_score": "8.00",
            "isauto": 0,
            "info": "",
            "km": "",
            "stem_url": "",
            "audiofile": "",
            "audiofile_suffix": "",
            "audiofile_title": "附件下载",
            "is_collect": 0,
            "status": 0,
            "is_play": 0,
            "issign": 0,
            "isok": 0,
            "isdone": 0,
            "getscore": 0,
            "comment": "",
            "ischeck": 0,
            "ps_title": "二、游戏题",
            "ps_info": "支持连连看、排一排、刮一刮、拼图组装等多种交互形式，让知识更具趣味性。",
            "topic_sub": [
              {
                "shorttag": "",
                "direction": 0,
                "type_id": 10,
                "typenm": "互动题",
                "score": "8.00",
                "topic_id": 57,
                "sub_id": 1,
                "isauto": 0,
                "para44_id": 0,
                "upload_explain": "",
                "options": [],
                "showway": "",
                "subinfo": "",
                "subanalysis": "",
                "sortid": 1,
                "file_name": "",
                "user_answer": [],
                "brief_answer": {},
                "user_status": -1,
                "answer_img": {},
                "topic_answer": [
                  {
                    "topic_id": 57,
                    "sub_id": 1,
                    "sortid": 1,
                    "ask": "",
                    "answer": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">在长期的实践中，广大劳动者逐渐培育形成了“执着专注、精益求精、一丝不苟、追求卓越”的工匠精神。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">执着专注既是一种锲而不舍的工作态度，也是一种埋头苦干的工作习惯。崔兴国从事水电装备制造工作30多年，带领团队持续攻关、突破创新，正是执着专注的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">精益求精即要有一颗进取之心，以高标准要求自己，不断钻研工艺知识、提高技能水平。为了保证水轮机组转轮平稳运行，实现转轮静平衡试验目标，崔兴国采用了精准导向工装和扶正调整技术，使各项参数指标均优于精品标准，正是精益求精的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">一丝不苟即做事认真，不放过任何一个细节。周晶辉面对烦琐的工作，勤勤恳恳，不断试验，成功探索出了可以使焊接时各个零部件受热均匀，减少车体变形情况的焊接工艺，正是一丝不苟的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">追求卓越即不断进取、敢于开拓创新、勇于突破自我。在没有技术参考的情况下，周晶辉用时一个多月，研究出了一套可在半小时内完成精准切割的切割方法，正是追求卓越的体现。<\/span><\/p>",
                    "askend": null,
                    "answer_id": 1,
                    "answer_url": "",
                    "answertitle": null,
                    "score": "8.00",
                    "operation_score": 0
                  }
                ],
                "topic_content": {
                  // 交互 排一排
                  key: 'section2.2.2.3.2', // *必填* 唯一标识
                  type: 'action', // *必填* 类型：交互
                  actionType: 2, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                  title: '排一排，完成细胞的凋亡过程。', // 标题
                  isExample: 1,
                  titleStyle: {},
                  content: {
                    // 排一排
                    key: 'action6',
                    sortData: [
                      {
                        key: 'action6.3',
                        actionKey: 'action6',
                        title: '碎片化',
                        cover: require("@/assets/images/books/bookExample/sort-icon-4.png"),
                        answerKey: 3
                      },
                      {
                        key: 'action6.4',
                        actionKey: 'action6',
                        title: '次级坏死',
                        cover: require("@/assets/images/books/bookExample/sort-icon-3.png"),
                        answerKey: 4
                      },
                      {
                        key: 'action6.2',
                        actionKey: 'action6',
                        title: '浓缩',
                        cover: require("@/assets/images/books/bookExample/sort-icon-2.png"),
                        answerKey: 2
                      },
                      {
                        key: 'action6.1',
                        actionKey: 'action6',
                        title: '正常',
                        cover: require("@/assets/images/books/bookExample/sort-icon-1.png"),
                        answerKey: 1
                      },
                    ],
                    answerData: [1, 2, 3, 4],
                    answerInfo: '凋亡是一个非常有序的过程。在此期间基因组被分解，细胞分裂成更小的碎片，这些碎屑被附近清理细胞碎片的细胞（吞噬细胞）所吞噬。除了摆脱受损的，有潜在危险的细胞，细胞凋亡对胚胎发育和神经修剪也十分关键。'
                  },
                },
                "video_list": [],
                "isok": 0,
                "isdone": 0,
                "concat_answer": "",
                "user_concat_answer": ""
              }
            ]
          },
          // 单项选择题
          {
            "key": "question1.3",
            "topic_id": 1,
            "id": 1,
            "type_id": 1,
            "typenm": "单项选择题",
            "shorttag": "",
            "showway": "",
            "topic_score": "1.00",
            "isauto": 0,
            "info": "",
            "km": "",
            "stem_url": "",
            "audiofile": "",
            "audiofile_suffix": "",
            "audiofile_title": "附件下载",
            "is_collect": 0,
            "status": 0,
            "is_play": 0,
            "issign": 0,
            "isok": 0,
            "isdone": 0,
            "getscore": 0,
            "comment": "",
            "ischeck": 0,
            "ps_title": "三、客观题",
            "ps_info": "支持单选、多选、判断等多种题型，答题结果及时反馈，并提供答案详解。",
            "topic_sub": [
              {
                "key": "question1.3.1",
                "shorttag": "",
                "direction": 0,
                "type_id": 1,
                "typenm": "单项选择题",
                "score": "1.00",
                "topic_id": 1,
                "sub_id": 1,
                "isauto": 0,
                "isExample": 1,
                "para44_id": 0,
                "upload_explain": "",
                "options": [],
                "showway": "",
                "subinfo": "<p><span style=\"font-family:微软雅黑\">造成亚健康的原因不包括（  ）。<\/span><\/p>",
                // "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">造成亚健康的原因不包括（  ）。<\/span><\/p>",
                "subanalysis": "<p><span style=\"font-family:微软雅黑\">导致亚健康的原因主要有以下几个方面：<\/span><\/p> <p><span style=\"font-family:微软雅黑\">①过度疲劳造成的精力体力透支；②人体自然衰老，机体器官开始老化出现的体力不支；③处于重病恢复期；④人体生物周期中的低潮导致维持生命的器官运行和新陈代谢等生物节律的紊乱；⑤个人的不良生活方式；⑥社会环境及人性需求产生的压力；⑦环境污染的影响。<\/span><\/p>",
                "sortid": 1,
                "file_name": "",
                "user_answer": [],
                "brief_answer": {},
                "user_status": -1,
                "answer": 4,
                "answer_img": {},
                "topic_answer": [
                  {
                    "topic_id": 1,
                    "sub_id": 1,
                    "sortid": 1,
                    "ask": "<p><span>A．过度疲劳<\/span><\/p>",
                    "answer": "0",
                    "askend": null,
                    "answer_id": 1,
                    "answer_url": "",
                    "answertitle": null,
                    "score": "0.00",
                    "operation_score": 0
                  },
                  {
                    "topic_id": 1,
                    "sub_id": 1,
                    "sortid": 2,
                    "ask": "<p><span>B．自然衰老<\/span><\/p>",
                    "answer": "0",
                    "askend": null,
                    "answer_id": 2,
                    "answer_url": "",
                    "answertitle": null,
                    "score": "0.00",
                    "operation_score": 0
                  },
                  {
                    "topic_id": 1,
                    "sub_id": 1,
                    "sortid": 3,
                    "ask": "<p><span>C．处于重病恢复期<\/span><\/p>",
                    "answer": "0",
                    "askend": null,
                    "answer_id": 3,
                    "answer_url": "",
                    "answertitle": null,
                    "score": "0.00",
                    "operation_score": 0
                  },
                  {
                    "topic_id": 1,
                    "sub_id": 1,
                    "sortid": 4,
                    "ask": "<p><span>D．经常运动<\/span><\/p>",
                    "answer": "1",
                    "askend": null,
                    "answer_id": 4,
                    "answer_url": "",
                    "answertitle": null,
                    "score": "0.00",
                    "operation_score": 0
                  },
                ],
                "video_list": [],
                "isok": 0,
                "isdone": 0,
                "concat_answer": "D",
                "user_concat_answer": ""
              }
            ]
          },
          // 简答题
          {
            "key": "question1.4",
            "topic_id": 57,
            "id": 57,
            "type_id": 4,
            "typenm": "简答题",
            "shorttag": "",
            "showway": "",
            "topic_score": "8.00",
            "isauto": 0,
            "info": "",
            "km": "",
            "stem_url": "",
            "audiofile": "",
            "audiofile_suffix": "",
            "audiofile_title": "附件下载",
            "is_collect": 0,
            "status": 0,
            "is_play": 0,
            "issign": 0,
            "isok": 0,
            "isdone": 0,
            "getscore": 0,
            "comment": "",
            "ischeck": 0,
            "ps_title": "四、主观题",
            "ps_info": "支持填空、简答等多种题型，答题结果及时反馈，并提供答案详解。",
            "topic_sub": [
              {
                "key": "question1.4.1",
                "shorttag": "",
                "direction": 0,
                "type_id": 4,
                "typenm": "简答题",
                "score": "8.00",
                "topic_id": 57,
                "sub_id": 1,
                "isauto": 0,
                "is_upload": 0,
                "isExample": 1,
                "para44_id": 0,
                "upload_explain": "",
                "options": [],
                "showway": "",
                "subinfo": "<p><span style=\"font-family:微软雅黑\">简述管理的职能。<\/span><\/p>",
                "subanalysis": "<p><span style=\"font-family:微软雅黑\">管理的职能是指管理者在协调组织成员的意见和行动的不一致时所体现出来的具体功能。管理的基本职能一般被简化为计划、组织、领导和控制四种。<\/span><\/p>",
                "sortid": 1,
                "file_name": "",
                "user_answer": [],
                "brief_answer": {},
                "user_status": -1,
                "answer_img": {},
                "answer": "计划,组织,领导,控制",
                "topic_answer": [
                  {
                    "topic_id": 57,
                    "sub_id": 1,
                    "sortid": 1,
                    "ask": "",
                    "answer": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">在长期的实践中，广大劳动者逐渐培育形成了“执着专注、精益求精、一丝不苟、追求卓越”的工匠精神。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">执着专注既是一种锲而不舍的工作态度，也是一种埋头苦干的工作习惯。崔兴国从事水电装备制造工作30多年，带领团队持续攻关、突破创新，正是执着专注的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">精益求精即要有一颗进取之心，以高标准要求自己，不断钻研工艺知识、提高技能水平。为了保证水轮机组转轮平稳运行，实现转轮静平衡试验目标，崔兴国采用了精准导向工装和扶正调整技术，使各项参数指标均优于精品标准，正是精益求精的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">一丝不苟即做事认真，不放过任何一个细节。周晶辉面对烦琐的工作，勤勤恳恳，不断试验，成功探索出了可以使焊接时各个零部件受热均匀，减少车体变形情况的焊接工艺，正是一丝不苟的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:微软雅黑\">追求卓越即不断进取、敢于开拓创新、勇于突破自我。在没有技术参考的情况下，周晶辉用时一个多月，研究出了一套可在半小时内完成精准切割的切割方法，正是追求卓越的体现。<\/span><\/p>",
                    "askend": null,
                    "answer_id": 1,
                    "answer_url": "",
                    "answertitle": null,
                    "score": "8.00",
                    "operation_score": 0
                  }
                ],
                "video_list": [],
                "isok": 0,
                "isdone": 0,
                "concat_answer": "",
                "user_concat_answer": ""
              }
            ]
          },
        ]
      },
      // 辅助工具
      {
        key: 'section2.2.2.4', // *必填* 唯一标识
        type: 'auxiliary', // *必填* 类型：
        title: '辅助工具', // 标题
        info: '重点勾画、智能报告，为学习提供个性化指导',
        content: [ // *必填* 内容列表
          // 辅助工具内容
          {
            key: 'section2.2.2.4.1',
            title: '一、划词功能',
            info: '划词勾画重点、记录心得，掌握个性化学习路径。',
            images: [
              require("@/assets/images/books/bookExample/auxiliary-img-1.gif"),
            ]
          },
          {
            key: 'section2.2.2.4.2',
            title: '二、思维导图',
            info: '标记的内容（笔记和高亮）可生成思维导图，快速梳理所学知识。',
            images: [
              require("@/assets/images/books/bookExample/auxiliary-img-2.gif"),
            ]
          },
          {
            key: 'section2.2.2.4.3',
            title: '三、学习报告',
            info: '学习记录全程跟踪，智能分析。学生可查看学习进度、学习时长、答题报告和错题本等；教师可查阅学生学习任务完成情况，系统自动统计学生分数。',
            images: [
              require("@/assets/images/books/bookExample/auxiliary-img-3.png"),
            ]
          },
        ]
      },

      // 视频
      // {
      //   key: 'section2.2.2.1', // *必填* 唯一标识
      //   type: 'video', // *必填* 类型：视频
      //   title: '多媒体集成-视频', // 标题
      //   info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
      //   cover: require("@/assets/images/bookContent/single_video.png"),
      //   content: [ // *必填* 视频列表
      //     {
      //       key: 'section2.2.2.1.1', // *必填* 唯一标识
      //       url: require("@/assets/video/1-3世上无难机器学习入门.mp4"), // *必填* 视频地址
      //       cover: require("@/assets/images/bookContent/single_video.png"), // 视频封面
      //       title: '世上无难事', // 视频标题
      //       subtitle: '——机器学习入门', // 视频副标题 只在全部显示时使用
      //       titleStyle: {
      //         // 根据需要是否加标题样式
      //         // fontFamily: 'xxx', // 字体，本地配置的字体
      //         // fontSize: 20, // 文字大小  默认：20
      //         // lineHeight: 40, // 行高  默认：36
      //         // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
      //         // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
      //         // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      //         // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      //         // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      //         // color: '#333', // 文本颜色  默认：#00a8ac
      //         // backgroundColor: '#FFF', // 背景颜色  默认：无
      //       }
      //     },
      //   ],
      // },
      // 图片集
      // {
      //   key: 'section2.2.2.2', // *必填* 唯一标识
      //   type: 'image', // *必填* 类型：图片
      //   title: '多媒体集成-图片集', // 标题
      //   info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
      //   cover: require("@/assets/images/bookContent/single_video.png"),
      //   content: [ // *必填* 图片列表
      //     {
      //       key: 'section2.2.2.2.1', // *必填* 唯一标识
      //       url: require("@/assets/images/bookContent/图1-1  机器学习与人类思考的类比.png"), // *必填* 图片地址
      //       title: '图 1-1 机器学习与人类思考的对比', // 图片标题
      //       titleStyle: {
    
      //       }
      //     },
      //     {
      //       key: 'section2.2.2.2.2', // *必填* 唯一标识
      //       url: require("@/assets/images/bookContent/图1-2  数据相关术语.png"), // *必填* 图片地址
      //       title: '图1-2 数据相关术语', // 图片标题
      //       titleStyle: {
              
      //       }
      //     },
      //     {
      //       key: 'section2.2.2.2.3', // *必填* 唯一标识
      //       url: require("@/assets/images/bookContent/图1-3  自然语言处理.png"), // *必填* 图片地址
      //       title: '图1-3  自然语言处理', // 图片标题
      //       titleStyle: {
              
      //       }
      //     },
      //     {
      //       key: 'section2.2.2.2.4', // *必填* 唯一标识
      //       url: require("@/assets/images/bookContent/图1-4  自动驾驶汽车.jpeg"), // *必填* 图片地址
      //       title: '图1-4  自动驾驶汽车', // 图片标题
      //       titleStyle: {
              
      //       }
      //     }
      //   ],
      // },
      // 音频集
      // {
      //   key: 'section2.2.2.3', // *必填* 唯一标识
      //   type: 'audio', // *必填* 类型：音频
      //   title: '多媒体集成-音频集', // 标题
      //   info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
      //   cover: require("@/assets/images/bookContent/single_video.png"),
      //   content: [ // *必填* 音频列表
      //     {
      //       key: 'section2.2.2.3.1', // *必填* 唯一标识
      //       url: require("@/assets/audio/audio.mp3"), // *必填* 音频播放地址
      //       cover: require("@/assets/images/bookContent/single_video_1.png"), // 音频封面
      //       title: '音频标题', // 音频标题
      //       titleStyle: {
      //         // 根据需要是否加标题样式
      //         fontFamily: 'xxx', // 字体，本地配置的字体
      //         fontSize: 20, // 文字大小  默认：20
      //         lineHeight: 40, // 行高  默认：36
      //         textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
      //         fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
      //         underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      //         fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      //         textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      //         color: '#333', // 文本颜色  默认：#00a8ac
      //         backgroundColor: '#FFF', // 背景颜色  默认：无
      //       }
      //     },
      //     {
      //       key: 'section2.2.2.3.2', // *必填* 唯一标识
      //       url: require("@/assets/video/1-2机器学习的发展历史.mp4"), // *必填* 暂时以视频替代
      //       // url: require("@/assets/audio/audio.mp3"), // *必填* 音频播放地址
      //       cover: require("@/assets/images/bookContent/single_video_1.png"), // 音频封面
      //       title: '音频标题', // 音频标题
      //       titleStyle: {
      //         // 根据需要是否加标题样式
      //         fontFamily: 'xxx', // 字体，本地配置的字体
      //         fontSize: 20, // 文字大小  默认：20
      //         lineHeight: 40, // 行高  默认：36
      //         textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
      //         fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
      //         underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      //         fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      //         textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      //         color: '#333', // 文本颜色  默认：#00a8ac
      //         backgroundColor: '#FFF', // 背景颜色  默认：无
      //       }
      //     }
      //   ]
      // },
      // 三维模型
      // {
      //   key: 'section2.2.2.4', // *必填* 唯一标识
      //   type: '3DModel', // *必填* 类型：音频
      //   title: '多媒体集成-三维模型', // 标题
      //   info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
      //   cover: require("@/assets/images/bookContent/single_video.png"),
      //   content: [ // *必填* 音频列表
      //     {
      //       key: 'section2.2.2.4.1', // *必填* 唯一标识
      //       url: 'https://file.bjjqe.net/wk/P01933/wk/0-1-1.htm', // *必填* 地址
      //       cover: require("@/assets/images/bookContent/single_video_1.png"), // 封面
      //       title: '三维模型标题', // 标题
      //       titleStyle: {}
      //     }
      //   ]
      // },
      // 自定义
      // {
      //   key: 'section2.2.2.5', // *必填* 唯一标识
      //   type: 'text', // *必填* 类型：
      //   title: '多媒体集成-自定义', // 标题
      //   info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
      //   cover: require("@/assets/images/bookContent/single_video.png"),
      //   content: [ // *必填* 音频列表
      //     // 交互 排一排
      //     {
      //       key: 'section2.2.2.5.1', // *必填* 唯一标识
      //       type: 'action', // *必填* 类型：交互
      //       actionType: 2, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
      //       title: '交互 -- 排一排', // 标题
      //       titleStyle: {},
      //       content: {
      //         // 排一排
      //         sortData: [
      //           {
      //             key: 'action2.1',
      //             title: '排序内容1',
      //             cover: require("@/assets/images/bookContent/图1-1  机器学习与人类思考的类比.png"),
      //             answerKey: 1
      //           },
      //           {
      //             key: 'action2.2',
      //             title: '排序内容2',
      //             cover: require("@/assets/images/bookContent/图1-2  数据相关术语.png"),
      //             answerKey: 2
      //           },
      //           {
      //             key: 'action2.4',
      //             title: '排序内容4',
      //             cover: require("@/assets/images/bookContent/图1-4  自动驾驶汽车.jpeg"),
      //             answerKey: 4
      //           },
      //           {
      //             key: 'action2.3',
      //             title: '排序内容3',
      //             cover: require("@/assets/images/bookContent/图1-3  自然语言处理.png"),
      //             answerKey: 3
      //           },
      //           {
      //             key: 'action2.5',
      //             title: '排序内容5',
      //             cover: require("@/assets/images/bookContent/图1-5  回归任务.png"),
      //             answerKey: 5
      //           },
      //         ],
      //         answerData: [3, 5, 1, 4, 2]
      //       },
      //     },
      //     // 正文
      //     {
      //       key: 'section2.2.2.5.2', // *必填* 唯一标识
      //       type: 'text', // *必填* 类型：正文
      //       content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
      //         {
      //           key: 'section2.2.2.5.2.1', // *必填* 唯一标识
      //           category: 'text', // *必填* 内容类型 text：文本 
      //           text: '文旌数字教材支持多媒体集成、内容拓展、交互练习、辅助工具四大功能版块，能够实现课堂教学与知识传授的生动性、趣味性，让学生可感可知、入脑入心，从而提升课堂教学效果和学习体验。', // *必填* 文本内容
      //           textStyle: {
      //           },
      //         },
      //       ],
      //       textStyle: {
      //         // fontFamily: 'xxx', // 字体，本地配置的字体
      //         // fontSize: 20, // 文字大小  默认：20
      //         // lineHeight: 40, // 行高  默认：36
      //         textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
      //         // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
      //         // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      //         // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      //         // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      //         // color: '#333', // 文本颜色  默认：#00a8ac
      //         // backgroundColor: '#FFF', // 背景颜色  默认：无
      //       },
      //     },
      //     // 交互 拼图/组装
      //     {
      //       key: 'section2.2.2.5.3', // *必填* 唯一标识
      //       type: 'action', // *必填* 类型：交互
      //       actionType: 4, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
      //       title: '交互 -- 拼图/组装', // 标题
      //       titleStyle: {},
      //       content: {
      //         // 拼图/组装
      //         background: {
      //           key: 'action5.1',
      //           title: '拼图背景',
      //           cover: require("@/assets/images/bookContent/图1-1  机器学习与人类思考的类比.png"),
      //           position: [
      //             {
      //               top: 50,
      //               left: 100,
      //               answerKey: 'key1'
      //             },
      //             {
      //               top: 50,
      //               right: 100,
      //               answerKey: 'key2'
      //             }
      //           ]
      //         },
      //         component: [
      //           {
      //             key: 'action5.2',
      //             title: '拼图内容1',
      //             cover: require("@/assets/images/bookContent/图1-3  自然语言处理.png"),
      //             answerKey: 'key2',
      //           },
      //           {
      //             key: 'action5.3',
      //             title: '拼图内容2',
      //             cover: require("@/assets/images/bookContent/图1-5  回归任务.png"),
      //             answerKey: 'key1',
      //           }
      //         ]
      //       },
      //     },
      //     // 正文
      //     {
      //       key: 'section2.2.2.5.4', // *必填* 唯一标识
      //       type: 'text', // *必填* 类型：正文
      //       content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
      //         {
      //           key: 'section2.2.2.5.4.1', // *必填* 唯一标识
      //           category: 'link', // *必填* 内容类型 text：文本 
      //           text: '文旌课堂', // *必填* 文本内容
      //           link: 'https://www.wenjingketang.com/',
      //           // linkIcon: require("@/assets/images/bookContent/bubble-icon-baidu.png"),
      //           textStyle: {
                  
      //           },
      //         },
      //         {
      //           key: 'section2.2.2.5.4.2', // *必填* 唯一标识
      //           category: 'text', // *必填* 内容类型 text：文本 
      //           text: '是一款为在校师生量身打造的数字化教育平台。平台综合了数字教材服务、图书服务、教学服务、考试服务、', // *必填* 文本内容
      //           textStyle: {
      //           },
      //         },
      //         {
      //           key: 'section2.2.2.5.4.3', // *必填* 唯一标识
      //           category: 'popover', // *必填* 内容类型 text：文本 
      //           text: '网络学习', // *必填* 文本内容
      //           popTitle: '网络学习', // 气泡的标题 气泡的标题与内容至少需要存在一个
      //           popText: '以互联网为载体的学习方式的统称', // 气泡的内容
      //           popLink: 'https://www.zgbk.com/ecph/words?SiteID=1&ID=138122&Type=bkzyb&SubID=42862', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
      //           textStyle: {
                  
      //           },
      //         },
      //         {
      //           key: 'section2.2.2.5.4.4', // *必填* 唯一标识
      //           category: 'text', // *必填* 内容类型 text：文本 
      //           text: '服务等多项服务（见图1），能够全面满足学生、教师、学校的学习、教学和管理需求。', // *必填* 文本内容
      //           textStyle: {
      //           },
      //         },
      //       ],
      //       textStyle: {
      //         // fontFamily: 'xxx', // 字体，本地配置的字体
      //         // fontSize: 20, // 文字大小  默认：20
      //         // lineHeight: 40, // 行高  默认：36
      //         textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
      //         // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
      //         // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      //         // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      //         // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      //         // color: '#333', // 文本颜色  默认：#00a8ac
      //         // backgroundColor: '#FFF', // 背景颜色  默认：无
      //       },
      //     },
      //   ]
      // },
      
    ],
  },
]
export default content